import {
  MATERIAL_SOURCE_ALL,
  MATERIAL_SOURCE_DELETE,
  MATERIAL_SOURCE_ERROR,
  MATERIAL_SOURCE_GET,
  MATERIAL_SOURCE_LOADING,
  MATERIAL_SOURCE_POST,
  MATERIAL_SOURCE_PUT,
} from '../../actions/types';

const initialState = {
  materialSource: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case MATERIAL_SOURCE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MATERIAL_SOURCE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case MATERIAL_SOURCE_POST:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_SOURCE_PUT:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_SOURCE_DELETE:
      return { isLoading: false, isCompleted: true };
    case MATERIAL_SOURCE_LOADING:
      return { isLoading: true, isCompleted: true };
    case MATERIAL_SOURCE_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
